import React, { useContext, useState, useEffect } from 'react';
import { AccountListContext } from '../../../context/AccountListContext';
import api from '../../../services/api';
import { truncateDescription, getUserStatsObject, recordActivity } from '../../../services/commonService';
import { Button } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal'
import ScreenLoader from '../../HtmlElements/ScreenLoader';
import Alert from '../../HtmlElements/Alert';
import Autocomplete from '../../HtmlElements/Autocomplete';
import AllAccountsTileView from './AllAccountsTileView';
import { Link, useLocation } from 'react-router-dom';
import AllAccountsTableView from './AllAccountsTableView';
import { useUser } from '../../../context/UserContext';
import * as FeatherIcon from 'react-feather';
import MessageDialog from '../../HtmlElements/MessageDialog';
import { useDispatch } from 'react-redux';
import { resetAllAccDepen } from '../../../store/features/actions/commonActions';
import axios from "axios";
import { API_BASE_URL } from '../../../config/apiConfig';

const apiForFile = axios.create({
    baseURL: API_BASE_URL,
});

apiForFile.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('access_token');
        if (token) {
            config.headers = {
                ...config.headers,
                Authorization: `Bearer ${token}`,
            };
        }

        if (config.data instanceof FormData) {
            if (config.headers && config.headers['Content-Type']) {
                delete config.headers['Content-Type'];
            }
        }

        return config;
    },
    (error) => Promise.reject(error)
);

apiForFile.defaults.responseType = 'blob';

export default function AllAccounts({setShowMoreModal}) {
    const dispatch = useDispatch();
    const {  updateMyReportContext, loading } = useContext(AccountListContext);
    const [show, setShow] = useState(false);
    const [all_accounts_view, setAllAccountsView] = useState('table'); // grid || table
    var currentUrl = useLocation().pathname;
    const [successMessage, setSuccessMessage] = useState('');
    const [showAddAccModal, setShowAddAccModal] = useState(false);
    const [loader, setLoader] = useState(false);
    const [error, setError] = useState('');
    const [addApiError, setApiError] = useState('');
    const [newClientName, setNewClientName] = useState('');
    const [newClientCode, setNewClientCode] = useState('');
    const [newAccountName, setNewAccountName] = useState('');
    const [newAccountCode, setNewAccountCode] = useState('');
    const { user } = useUser();
    const [messageInfo, setMessageInfo] = useState({})

    const [searchTerm, setSearchTerm] = useState('');

    useEffect(() => {
          dispatch(resetAllAccDepen())
    }, [])

    useEffect(() => {
        setNewClientName(user?.company_name);
        setNewClientCode(user?.company_id);
    }, [user]);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const modalAddAccount = () => {
        setShowAddAccModal(true);
    };

    const handleAutoCompleteChange = (e) => {
        const { name, value, code } = e.target;
        if(name === "account_name"){
          setNewAccountName(value)
          setNewAccountCode(code)
        }
    }

    const handleAddAccount = async () => {
        try {
          const response = await api.post('/accounts/add_account', {
            account_name: newAccountName?.trim(),
            account_code: newAccountCode?.trim(),
            client_name: newClientName?.trim(),
            client_code: newClientCode?.trim()
          });

          if (response.data.status === 201 || response.data.status === 200) {
            await updateMyReportContext();
            handleAddAccClose();
            
            setMessageInfo({
                message_type: 'success',
                message: 'Account request has been sent successfully.',
            });

          }else{
            setApiError(response.data.result.message || 'An error occurred while saving the company.');
          }

        } catch (err) {
          setError(err.message || 'Failed to add account');
        }
        setLoader(false);
    };

    const handleAddAccClose = () => {
        setShowAddAccModal(false);
        setNewAccountName('');
        setNewAccountCode('');
    };

    const changeAccountView = (view_type) => {
        let type = (view_type == 'grid') ? "tile_view" : "table_view";
        const userStat = getUserStatsObject("All Companies", type, "Page Source: Companies", currentUrl);
        recordActivity(userStat);
        setAllAccountsView(view_type);
    }

    const hideMessageDialog = () => {
        setMessageInfo({});
    };

    // ++++++++++++++++++++++++++++++++++

    const handleAccountPlanDownload = async (account_code, client_code) => {
        try {
            const formData = new FormData();
            formData.append("account_code", account_code);
            formData.append("client_code", client_code);

            const response = await apiForFile.post(
                "/accounts/downloadAccountPlan",
                formData
            );

            const contentDisposition = response.headers['content-disposition'];
            let filename = "account_plan.xlsx";

            if (contentDisposition) {
                const filenameRegex = /filename\*?=['"]?(?:UTF-\d['"]*)?([^;\r\n"']*)['"]?;?/gi;
                const matches = filenameRegex.exec(contentDisposition);
                if (matches && matches[1]) {
                    filename = matches[1]
                        .replace(/^utf-8''/i, '')
                        .replace(/%20/g, ' ');
                }
            }

            const contentType = response.headers['content-type'];
            let blobType = contentType;

            if (!blobType || blobType === 'application/octet-stream') {
                const ext = filename.split('.').pop().toLowerCase();
                blobType = {
                    xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                    xls: 'application/vnd.ms-excel',
                    pdf: 'application/pdf',
                }[ext] || 'application/octet-stream';
            }

            const blob = new Blob([response.data], { type: blobType });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", filename);
            document.body.appendChild(link);
            link.click();

            setTimeout(() => {
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            }, 100);
        } catch (error) {
            // handleApiError(error, "Failed to download file");
        }
    };

    const handleSearch = (e) => {
        // console.log("SEARCH TERM: "+e.target.value);
        setSearchTerm(e.target.value);
    }
    // ++++++++++++++++++++++++++++++++++

    return (
        <div className='all_acccounts_wrapper' style={{
            backgroundColor: "#ffffff",
            padding: "20px",
            maxWidth:'99%',
            borderRadius: "12px",
            minHeight: "100vh"
        }}>
        {successMessage && <Alert type="success" message={successMessage} />}

        {loading && <ScreenLoader/>}

        <MessageDialog
        show={messageInfo?.message}
        handleClose={hideMessageDialog}
        messageInfo={messageInfo} />

        {error && <Alert type="danger" message={error} />}
            <div className="all_acccounts_block">
                <h5 className="all_acccounts_head">
                <FeatherIcon.Briefcase className='comp_icon' />
                    <span style={{'paddingRight': '5px'}}>All Competitors</span> 
                    <div className='pl-3 circle_ready'>
                        <div id="outer-circle">
                            <div id="inner-circle">
                            </div>
                        </div>
                    </div>
                </h5>
                <div className='d-flex toggle_block'>

                    {/* <div className='filter_btn_block'>
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Search..."
                            style={{
                                width: "350px",
                                height: "32px",
                                padding: "8px 4px 8px 12px",
                                border: "0.5px solid #42464847",
                                backgroundColor: "#FFFFFF",
                                fontSize: "12.5px",
                                lineHeight: "15.63px",
                                fontWeight: "500",
                                color: "#9595A1"
                            }}
                            value={searchTerm}
                            onChange={(e) => handleSearch(e)}
                        />
                    </div> */}
                    {/* <div className='toggle_list_tableview mr-2'>
                        <Link className={`table_view ${all_accounts_view === 'table' ? 'active' : ''}`}
                            style={{
                                fontSize: "12px",
                                lineHeight: "15px",
                                textDecoration: "none",
                                padding: "7px 12px 7px 12px",
                                width: "56px",
                                height: "27px",
                                radius: "7px",

                            }}
                            onClick={()=> changeAccountView('table')}
                            >
                            Table
                        </Link>
                        <Link className={`grid_view ${all_accounts_view === 'grid' ? 'active' : ''}`}
                            style={{
                                fontSize: "12px",
                                lineHeight: "15px",
                                textDecoration: "none",
                                padding: "7px 12px 7px 12px",
                                width: "56px",
                                height: "27px",
                                radius: "7px"
                            }}
                            onClick={()=> changeAccountView('grid')}>
                            Card
                        </Link>
                    </div> */}

                    {/* <div className='filter_btn_block'>
                        <Button variant="primary" onClick={handleShow} className='filter_btn'>Filter <img src='/img/icons/arrowheads.png' alt="image" className='filter_image' width=""/> </Button>
                    </div> */}

                    {/* <div className="align-right">
                        <Link
                            style={{
                                width: "128px",
                                height: "30px",
                                top: "20px",
                                radius: "8px",
                                // padding: "12px",
                                gap: "10px",
                                backgroundColor: "#232428",
                                weight: "600",
                                fontSize: "13px",
                                lineHeight: "16.25px",
                                color: "#FFFFFF"
                            }}
                            className="add_account_companies"
                            to="#"
                            // onClick={modalAddAccount}
                            onClick={() => setShowMoreModal(true)}
                        >
                        <FeatherIcon.Plus className='add_icon' />  Add Account
                        </Link>
                    </div> */}

                </div>
            </div>

            {all_accounts_view === 'grid' && <AllAccountsTileView searchTerm={searchTerm} handleAccountPlanDownload={handleAccountPlanDownload} /> }
            {all_accounts_view === 'table' && <AllAccountsTableView searchTerm={searchTerm} handleAccountPlanDownload={handleAccountPlanDownload} /> }

            <Modal show={show} onHide={handleClose} className='custom_modal_filter' centered>
                <Modal.Header closeButton className='custom_modal_header'>
                    <Modal.Title>Filters</Modal.Title>
                </Modal.Header>
                <Modal.Body className='custom_modal_body'>
                    <div className='custom_filter_body'>
                        <div className='filter_block'>
                            <div className='filter_head'>
                            <FeatherIcon.Settings className='top_icons' /> Industry
                            </div>
                            <div className='checkbox_custom'>
                            <label className='checkbox_label'>
                                <input type="checkbox" className='checkbox_input'/>
                                <span className='checkbox_label_span'>Oil & Gas Equipment</span>
                            </label>
                            </div>
                            <div className='checkbox_custom'>
                            <label className='checkbox_label'>
                                <input type="checkbox" className='checkbox_input'/>
                                <span className='checkbox_label_span'>Retail Fuel Distribution</span>
                            </label>
                            </div>
                            <div className='checkbox_custom'>
                            <label className='checkbox_label'>
                                <input type="checkbox" className='checkbox_input'/>
                                <span className='checkbox_label_span'>Natural Gas</span>
                            </label>
                            </div>
                            <div className='checkbox_custom'>
                            <label className='checkbox_label'>
                                <input type="checkbox" className='checkbox_input'/>
                                <span className='checkbox_label_span'>Storage Facilities</span>
                            </label>
                            </div>
                            <div className='show_more_filters'>
                                <a href="#" className='link_show'><FeatherIcon.Plus className='plus_icon' />Show more</a>
                            </div>                
                        </div>
                        <div className='filter_block'>
                            <div className='filter_head'>
                            <FeatherIcon.PieChart className='top_icons' /> Relevance
                            </div>
                            <div className='checkbox_custom'>
                            <img src='/img/progess_bar.png' alt="image" className='chart_pie_icon' width=""/>
                            </div>                             
                        </div>
                        <div className='filter_block'>
                            <div className='filter_head'>
                            <FeatherIcon.DollarSign className='top_icons' /> Revenue
                            </div>
                            <div className='checkbox_custom'>
                            <img src='/img/progess_bar.png' alt="image" className='chart_pie_icon' width=""/>
                            </div>
                                    
                        </div>
                    </div>
                </Modal.Body>

                <Modal.Footer className='custom_modal_footer'>
                    <Button variant="link" onClick={handleClose} className='clearall'>
                        Clear All
                    </Button>
                    <Button variant="link" onClick={handleClose} className='applyfilter'>
                        Apply Filters
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal show={showAddAccModal} onHide={handleAddAccClose} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Add Account</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className='row'>
                    {addApiError && <div className="alert alert-danger">{addApiError}</div>}
                    </div>

                    <div className="row">
                        <div className="col-md-12">
                        <label htmlFor="labelAccountName" className="form-label custom_label">Account Name <span className='red'>*</span></label>
                            <Autocomplete
                            name="account_name"
                            key="suggest_account_name"
                            value={newAccountName}
                            onChange={handleAutoCompleteChange}
                            placeholder="Account Name"
                            element_field_key="account_name"
                            apiUrl="/company_profiles/suggest_company_name"
                            labelKey="name"
                            valueKey="code"/>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleAddAccClose}>
                        Close
                    </Button>
                    <Button variant="danger" onClick={handleAddAccount}>
                        Submit
                    </Button>
                </Modal.Footer>
            </Modal>

        </div>
    );
}
